import i18n from "@/lib/i18n";

const localeMap: Record<string, string> = {
  fr: "fr-FR",
  en: "en-US",
  es: "es-ES",
};

export function getDateLocale(): string {
  return localeMap[i18n.language] ?? "fr-FR";
}
